<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" class="pt-0" TRANSACTIONS>
            <v-row>
              <v-col cols="12" PANNELS>
                <v-card TRANSACTIONS>
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLEICON>
                            <v-icon size="40" color="secondary">local_shipping</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic?'arFont':'enFont'} black--text`">ملاحظات الشحن</div>
                            <div :class="`${arabic?'arFont':'enFont'} grey--text`">كل ما يجب ان تعرفه بخصوص الشحن</div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12">
                            <v-row class="align-center">
                              <v-col cols="12">
                                <v-card color="pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          مراحل تغيير الطلب علي الموقع بعد تسجيله
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          تم استلام الطلب
                                        </div>
                                        <div class="text-right">
                                          حيث يقوم فريق نينجا سيلرز المسؤول عن تأكيد الطلبات بالتواصل مع الزبون و تأكيد الطلب و تسجيل بيانات العميل من اسمه و عنوانه و تفاصيل المنتج و التأكيد على سعره حسب تعبئته من قبلك ، و نقوم بعملية تأكيد الطلبات من الساعة التاسعة صباحا إلى الساعة الخامسة مساء ، كما ان يقوم الفريق بالتواصل مع الزبون أكثر من مرة في أوقات مختلفة حتى يتم تأكيد الطلب ، في حالة تسجيل الطلب على الموقع قبل الساعة 4 مساء فأنه يتم تأكيد الطلب في نفس اليوم ، أما في حالة التسجيل بعد الساعة 4 مساء يتم تأكيده في اليوم التالي
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          تم الغاء الطلب
                                        </div>
                                        <div class="text-right">
                                          يقوم فريق نينجا سيلرز بالتواصل مع العميل أكثر من مرة في حال لم يتم الرد في المرة الاولى و تكون هذه المرات في أوقات مختلفة خلال اليوم ، و في حال لم يتم الرد من قبل العميل بعد 7 محاولات خلال 4 أيام فإنه يتم إلغاء الطلب، كما تظهر هذه الحالة على الطلب في حال تم الغاء الطلب من قبل الزبون
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          تم تأكيد الطلب
                                        </div>
                                        <div class="text-right">
                                          بعد أن يقوم فريق نينجا سيلرز بتأكيد الطلب يتم فرز الطلبات حسب كل دولة و ارسالها الى المستودعات وتجهيزها وتسليمها لشركات التوصيل خلال مدة يوم الى يومين عمل من تأكيد الطلب
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          تعليق التوصيل
                                        </div>
                                        <div class="text-right">
                                          في حال وجود أي مشكلة بعنوان الزبون او معلوماته بعد عملية تأكيد الطلب أو عدم توفر المنتج في المخزون فإنه يتم تعليق الطلب مؤقتا لحين شحن الطلب مع شركة التوصيل
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          الشحنة خارجة للتوصيل
                                        </div>
                                        <div class="text-right">
                                          تم تسليم الطلب لشركة التوصيل حيث ستقوم بتوصيل الشحنة للزبون خلال المدة التي تم تحديدها مع الزبون أثناء مكالمة التأكيد حيث أن مدة التوصيل تختلف من دولة الى أخرى
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          تم التوصيل
                                        </div>
                                        <div class="text-right">
                                          تم توصيل الطلب للزبون و قبض قيمة التحصيل منه حيث سيتم عكس حالة الطلب على موقع نينجا سيلرز خلال يوم عمل من استلام الزبون للطلب ، و يظهر بعدها ربح الطلب في خانة الربح الخاصة بك حيث سيكون قابل للتحويل بعد 7 ايام من هذا التحديث
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          جدول أسعار الشحن
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2 text-center`">
                                      <img src="/images/newshippmentprice.jpg" width="50%">
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              
                              <v-col cols="12">
                                <v-card color="pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          سياسة الترجيع والتبديل
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="text-right">
                                          يمكنك ترجيع طلب الزبون أو تبديله عن طريق فتح الطلب عن طريق مراسلتنا على الايميل
                                        </div>
                                        <div class="text-right">
                                          Support@ninjasellers.com
                                        </div>
                                        <div class="text-right">
                                          و تزويدنا ب صورة للمنتج تبين العطل ان وجد و صورة عن فاتورة الاستلام ، إذا كان التبديل بناء على عطل موجود في المنتج فإنه يتم التبديل مجانا بدون اي تكاليف اضافية ، اما في حالة طلب التبديل بدون وجود اي عطل او خطأ في الطلب فإنه يتم اقتطاع 40% من قيمة الطلب وارسال المنتج الجديد للزبون مع حساب فرق السعر ان وجد ، وفي حال رغبة الزبون بالإرجاع فيجب تزويدنا باسمه من اربع مقاطع حسب جواز السفر و يتم خصم 40% من المبلغ المدفوع و إرجاع الباقي للزبون خلال مدة 14-21 يوم من طلب الترجيع حيث سيظهر التحديث على موقع نينجا سيلرز ، و يشترط أن تكون القطعة المرتجعة من عند الزبون سليمة و غير مستخدمة و قابلة للبيع مرة أخرى و بخلاف ذلك لا يمكن اتمام عملية التبديل او الارجاع
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          طلبات الصرف وسحب الأرباح
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="text-right">
                                          سوف تكون ارباحك قابلة للصرف بعد 7 أيام من تحديث استلام الزبون للطلب على موقع نينجا سيلرز ، يمكنك طلب تحويل الارباح في اي وقت حيث سيقوم فريق نينجا سيلرز تحويل أرباحك خلال يوم عمل من طلبك ، و يجب تزويدنا بمعلومات التحويل المناسبة حسب دولتك
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          نفاذ المخزون 
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="text-right">
                                          عند نفاذ مخزون اي منتج على نينجا سيلرز لن يكون هذا المنتج  متاح في الموقع  ، و اذا كنت  تقوم بتعبئة طلبات على هذا المنتج فلن تصل  هذه الطلبات الى نينجا سيلرز و سنقوم باشعارك فورا على بريدك الالكتروني  المسجل لدينا ب نفاذ المخزون من هذا المنتج لذا نرجو منك متابعة بريدك الالكتروني بشكل دوري وباستمرار حتى نستطيع شحن طلباتك باستمرار لعملائك بدون توقف ، كما يتوجب عليك متابعة  الكميات  المتاحة عند كل منتج  من المنتجات الموجودة على الموقع باستمرار حيث ان المخزون الموجود يتناقص بشكل فوري .
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          لزيادة نسبة توصيل الطلبات يمكنك اتباع النصائح التالية
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="text-right">
                                          1. تأكد من تزويدنا ب بيانات الزبون بشكل كامل من اسم ثلاثي و رقم تلفون اول و رقم تلفون ثاني حتى تزيد من فرصة رد الزبون و تأكيد الطلب.
                                        </div>
                                        <div class="text-right">
                                          2. اخطار الزبون بأنه سيتم التواصل معه خلال 24 ساعة من طلبه من رقم غريب لتأكيد الطلب.
                                        </div>
                                        <div class="text-right">
                                          3. حاول أن تجعل الزبون يكتب العنوان الخاص به بشكل كامل و في حال وجود أي نقص بالعنوان لا تقلق فأن فريق تأكيد طلبات نينجا سيلرز سيقوم بأخد كامل التفاصيل الخاصة بالزبون حتى يتم توصيل الطلب.
                                        </div>
                                        <div class="text-right">
                                          4. حاول أن تقوم بتعبئة طلباتك مباشرة في موقع نينجا سيلرز بدون تأخير.
                                        </div>
                                        <div class="text-right">
                                          5. تأكيد السعر النهائي للزبون شامل التوصيل و الضريبة ان وجدت بشكل واضح . 
                                        </div>
                                        <div class="text-right">
                                          6. عدم المبالغة في طريقة الاعلان للمنتج حتى يكون المنتج مطابق للعميل عند رؤيته على الطبيعة.
                                        </div>
                                        <div class="text-right">
                                          7. متابعة طلباتك على موقع نينجا سيلرز و اخبارنا في حال وجود اي مشاكل حتى يتم معالجتها بأسرع وقت. 
                                        </div>
                                        <div class="text-right">
                                          8. التوضيح للزبون بأنه يمكنه التواصل معك دائما عن طريق وسائل التواصل المتاحة لديك حتى تزيد من نسبة استلام العملاء للطلبات.
                                        </div>
                                        <div class="text-right">
                                          تأكد ان فريق نينجا سيلرز موجود لخدمتك دائما و جاهز للتعاون معك باعطائك التحليلات الأولية اول بأول و تلبيتة كامل  احتياجك لتحصل على اعلى نسبة تأكيد و توصيل طلبات
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="pa-4" flat>
                                  <v-row class="align-center">
                                    <v-col cols="12" :class="`${arabic?'arFont':'enFont'} mx-2`">
                                        <div class="`${arabic?'arFont':'enFont'} text-right my-5`" style="font-size:18px;font-weight:bold;">
                                          الدول والمدن المتاحة
                                        </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                              <v-col cols="12">
                                <v-card color="grey lighten-4 pa-4" flat>
                                  <v-row class="align-start">
                                    <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} px-2`">
                                      <v-btn @click="exportAll()" color="primary" :class="`${arabic?'arFont':'enFont'}`">
                                        تحميل قائمة بكافة الدول والمدن
                                      </v-btn>
                                    </v-col>
                                    <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} px-2`" v-for="(country, c) in countries" :key="'count'+c">
                                      <div class="text-right">
                                        <img width="53px" style="filter:drop-shadow(2px 2px 4px rgb(0 0 0 / 38%));" :src="`/flags/${country.alpha2Code.toLowerCase()}.png`" alt="">
                                        <div>
                                          {{countries_ar[country.alpha2Code.toLowerCase()]}}
                                          <v-chip color="primary" small>{{country.alpha2Code}}</v-chip>
                                        </div>
                                        <div class="py-1">
                                          <v-btn small @click="exportCountry(country.alpha2Code)" color="primary" :class="`${arabic?'arFont':'enFont'}`">
                                            تحميل مدن {{countries_ar[country.alpha2Code.toLowerCase()]}}
                                          </v-btn>
                                        </div>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Search from '@/components/Search'
import json2csv from 'json2csv'
export default {
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      firstPanel:true,
      secondPanel:false,
      thirdPanel:false,
      selectedPanel:'firstPanel',
      subitems:[
        {
          text:'المعلومات الشخصية',
          icon:'person',
          value:'firstPanel'
        },
        {
          text:'تغيير كلمة المرور',
          icon:'password',
          value:'secondPanel'
        },
        {
          text:'الاحالات',
          icon:'loyalty',
          value:'thirdPanel'
        },
      ],
    
      countries:[],
    }
  },
  methods: {
    async loadInfo(){
      let a = await this.$store.dispatch('getResource', {resource:'/info'})
      this.countries = a.countries
      // console.log(a)
    },
    exportSimpleData(data, name){
      let a = json2csv.parse(data)
      // console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'failed_export'
      link.setAttribute("download", `${n}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    exportAll(){
      let exp = []
      let c = this.countries
      for (let i = 0; i < c.length; i++) {
        const country = c[i];
        for (let h = 0; h < country.cities.length; h++) {
          const city = country.cities[h];
          let ex = {
            city:city.name,
            country: country.alpha2Code,
            fee:city.fee,
          }
          if(city.region && city.region.name) {
            ex.district = city.region.name
          }
          exp.push(ex)
        }
      }
      this.exportSimpleData(exp, 'all_available_cities_ninja_sellers')
    },
    exportCountry(cc){
      let exp = []
      let c = this.countries.filter(x=> x.alpha2Code == cc)[0]
      
      for (let h = 0; h < c.cities.length; h++) {
        const city = c.cities[h];
        let ex = {
          city:city.name,
          country: c.alpha2Code,
          fee:city.fee,
        }
        if(city.region && city.region.name) {
          ex.district = city.region.name
        }
        exp.push(ex)
      }
      this.exportSimpleData(exp, cc + '_cities_ninja_sellers')
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    countries_ar() {
      return this.$store.state.countries_ar
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    this.loadInfo()
  },
}
</script>

<style>

</style>